import { Modal } from "react-bootstrap-v5"

type Props = {
    show: boolean;
    title: string;
    content: string;
    acceptContent: string;
    onClose: (value: boolean) => void;
}

export const MessageSimpleModal = ({ show, title, content, acceptContent, onClose }: Props) => {
    return (
        <Modal
            tabIndex='-1'
            dialogClassName="message-simple-modal"
            contentClassName="message-simple-modal-content"
            show={show}
        >
            <h3>{title}</h3>
            <p>{content}</p>
            <div className="d-flex flex-row w-100 justify-content-between align-items-center">
                <button className="btn-action-secundary" onClick={() => onClose(false)}>CANCEL</button>
                <button className="btn-action-primary" onClick={() => onClose(true)}>{acceptContent}</button>
            </div>
        </Modal>
    )
}